import React, { useEffect, useState } from 'react';
import PanelShell from '../PanelShell';

const RisingEdgePanel = ({ nodeType, nodeId, data, onChange }) => {
  const [signal, setSignal] = useState(data?.signal || '');
  useEffect(()=>{ setSignal(data?.signal || ''); }, [data]);
  if (nodeType !== 'RisingEdge') return null;
  const save=()=> onChange({ label:'RisingEdge', signal, Title:`RisingEdge(${signal})` });
  return (
    <PanelShell title="Rising Edge" onSave={save}>
      <label>Sinyal</label>
      <input value={signal} onChange={e=>setSignal(e.target.value)} />
    </PanelShell>
  );
};
export default RisingEdgePanel;
